import { PartnerSortDropdown } from "@/components/dropdown/PartnerSortDropdown";
import { Button } from "flowbite-react";
import { ButtonColor } from "../../common/enum/button-color";
import { PartnerOrder } from "../../common/enum/partner-order";
import { FilterFillIcon } from "../icon/FilterFillIcon";
import { FilterOutlineIcon } from "../icon/FilterOutlineIcon";
import { PartnerNameSearch } from "../search/PartnerNameSearch";

interface Props {
  totalElements: number;
  keyword: string;
  sortType: PartnerOrder;
  hasIncentiveDiscount: boolean;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSortChange: (sortType: PartnerOrder) => void;
  handleIncentiveDiscount: () => void;
}

export const PartnerBar: React.FC<Props> = ({
  totalElements,
  keyword,
  sortType,
  hasIncentiveDiscount,
  handleSearchChange,
  handleSortChange,
  handleIncentiveDiscount,
}) => {
  return (
    <div className="flex items-center justify-between h-[64px]">
      <div>{totalElements}명의 파트너</div>
      <div className="flex gap-[16px]">
        <PartnerNameSearch
          keyword={keyword}
          placeholder="파트너명 or 상호명 or 이메일 or 사업자번호 or 가입코드 검색"
          handleSearchChange={handleSearchChange}
        />
        <Button
          size="xs"
          color={ButtonColor.WHITE}
          onClick={handleIncentiveDiscount}
        >
          <div
            className={`flex justify-center items-center gap-[8px] ${
              hasIncentiveDiscount
                ? "text-semantic-success-success-primary"
                : "text-semantic-text-body"
            }`}
          >
            {hasIncentiveDiscount ? (
              <div className="flex w-[16px] h-[16px] items-center justify-center">
                <FilterFillIcon />
              </div>
            ) : (
              <FilterOutlineIcon size={16} />
            )}
            인센티브 할인
          </div>
        </Button>
        <PartnerSortDropdown
          sortType={sortType}
          handleSortChange={handleSortChange}
        />
      </div>
    </div>
  );
};
